import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { getIntegration } from "../../../actions/integrationActions";
import ArgoIconButtonToggleViewFieldTextHook from "../../common/ArgoIconButtonToggleViewFieldTextHook";
import { getIntegrationTypeName } from "../../../constants/integrationConstants";


function IntegrationReviewHook(props) {
    const [viewApiKey1, setViewApiKey1] = useState(false);
    const [viewApiKey2, setViewApiKey2] = useState(false);
    
    const dispatch = useDispatch();
    const integration = useSelector(state => props.id ? state.integration : undefined);

    useEffect(() => {
        if (props.id) {
            dispatch(getIntegration(props.id));
        }
    }, [props.id, dispatch]);

    const toggleViewApiKey = (fieldName, toggle) => {
        if (fieldName === "viewApiKey1") {
            setViewApiKey1(toggle);
        } else if (fieldName === "viewApiKey2") {
            setViewApiKey2(toggle);
        }
    };

    const rootStyle = {
        padding: "32px",
        justifyContent: "space-between",
        width: "90%",
        maxHeight: "fit-content",
        height: "fit-content",
        minHeight: "fit-content",
        ...props.style
    };

    return (
        (integration && (typeof integration.apiKey1 !== "undefined") && (typeof integration.apiKey2 !== "undefined")) ?
            <div style={rootStyle}>

                <div id="IntegrationReview-name-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{"Name:"}</div>
                    <div style={{width: "15px"}}></div>
                    <div style={{paddingBottom: "12px", fontSize: "16px", fontWeight: "bold"}}>{integration.name}</div>
                </div>

                <div id="IntegrationReview-type-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{"Type:"}</div>
                    <div style={{width: "15px"}}></div>
                    <div style={{paddingBottom: "12px", fontSize: "16px", fontWeight: "bold"}}>{getIntegrationTypeName[integration.integrationType]}</div>
                </div>

                <div id="IntegrationReview-url-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{"URL:"}</div>
                    <div style={{width: "15px"}}></div>
                    <div style={{paddingBottom: "12px", fontSize: "16px", fontWeight: "bold"}}>{integration.integrationUrl}</div>
                </div>

                <div id="IntegrationReview-api1-div" style={{width: "100%", display: "flex", alignItems: "center"}}>
                    <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{integration.integrationType === "OAUTH2" ? "Client ID" : "API Key 1:"}</div>

                    <div style={{width: "15px"}}></div>

                    <div style={{paddingBottom: "12px", fontSize: "16px", fontWeight: "bold"}}>{viewApiKey1 ? integration.apiKey1 : "*".repeat(integration.apiKey1.length)}</div>

                    <div style={{width: "15px"}}></div>

                    <ArgoIconButtonToggleViewFieldTextHook
                        fileName="integration-viewer"
                        fieldName="viewApiKey1"
                        marginTop="-15px"
                        onClick={toggleViewApiKey}
                    />

                </div>

                <div id="IntegrationReview-api2-div" style={{width: "100%", display: "flex", alignItems: "center"}}>
                    <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{integration.integrationType === "OAUTH2" ? "Secret" : "API Key 2:"}</div>

                    <div style={{width: "15px"}}></div>

                    <div style={{paddingBottom: "12px", fontSize: "16px", fontWeight: "bold"}}>{viewApiKey2 ? integration.apiKey2 : "*".repeat(integration.apiKey2.length)}</div>

                    <div style={{width: "15px"}}></div>

                    <ArgoIconButtonToggleViewFieldTextHook
                        fileName="integration-viewer"
                        fieldName="viewApiKey2"
                        marginTop="-15px"
                        onClick={toggleViewApiKey}
                    />
                </div>

                {integration.integrationType === "OAUTH2" ?
                    <div>
                        <div id="IntegrationReview-info3-div" style={{width: "100%", display: "flex"}}>
                            <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{"Token Endpoint:"}</div>
                            <div style={{width: "15px"}}></div>
                            <div style={{
                                paddingBottom: "12px",
                                fontSize: "16px",
                                fontWeight: "bold"
                            }}>{integration.info3}</div>
                        </div>

                        <div id="IntegrationReview-info4-div" style={{width: "100%", display: "flex"}}>
                            <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{"Grant Type:"}</div>
                            <div style={{width: "15px"}}></div>
                            <div style={{
                                paddingBottom: "12px",
                                fontSize: "16px",
                                fontWeight: "bold"
                            }}>{integration.info4}</div>
                        </div>

                        <div id="IntegrationReview-info5-div" style={{width: "100%", display: "flex"}}>
                            <div style={{paddingBottom: "12px", fontSize: "16px", color: "silver"}}>{"Scope:"}</div>
                            <div style={{width: "15px"}}></div>
                            <div style={{
                                paddingBottom: "12px",
                                fontSize: "16px",
                                fontWeight: "bold"
                            }}>{integration.info5}</div>
                        </div>
                    </div> : ""
                }

            </div>
            : ""
    );
}

IntegrationReviewHook.defaultProps = {
    integration: undefined
};

IntegrationReviewHook.propTypes = {
    integration: PropTypes.object,
    style: PropTypes.object,
    id: PropTypes.string,
};

export default IntegrationReviewHook;